import { SegmentService } from 'app/segment/segment.service';

export abstract class HomePageBaseComponent {
  constructor(protected segmentService: SegmentService) {}

  abstract get activityLevel();
}
